window.addEventListener("load", function () {
    mapboxgl.accessToken = 'pk.eyJ1IjoicHN5Y2xlIiwiYSI6ImNsaHVrenlnZzAwdGUzamxzbXVlNHA3dGsifQ.eQUKECAhNVbjIccZxDvugQ';
    let map;

    function createMap(lng, lat) {
        map = new mapboxgl.Map({
            container: 'map', zoom: 15,
            style: 'mapbox://styles/psycle/clhujyync004601pi9fwpdder',
            center: [lng, lat],
        });

        new mapboxgl.Marker()
            .setLngLat([lng, lat])
            .addTo(map);
    }

    window.createMap = createMap;

    const maps = document.querySelectorAll("[data-mapbox-map]");
    maps.forEach(map => {
        createMap(map.dataset.lng, map.dataset.lat);
    });
});